/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Card } from "antd";
import { Collapse, Form, Flex, Row, Col, Space } from "antd";
import { Input, Button, Table, message, DatePicker, Typography } from "antd";
import {
  SearchOutlined,
  ClearOutlined,
  FileAddOutlined,
} from "@ant-design/icons";
import { accessColumn } from "./model";
import { TBBNTSTYLE, TBICONSTYLE } from '../../../constant/constant.js';
import { TbFileExport } from "react-icons/tb";
import dayjs from "dayjs";
import ReportService from "../../../service/Report.service";
import { useTableCookie } from "../../../hooks/useTableCookie";

const reportService = ReportService();
const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
};
const DATE_FIELDS = ["podate"];

const RangePicker = DatePicker.RangePicker;
const SalesCostAccess = () => {
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const { getSearch, saveSearch, getPagination, savePagination, getActiveSearch, saveActiveSearch, clearSearch } = useTableCookie("ais_report_salescost");

  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState(() => getActiveSearch());
  const [pagination, setPagination] = useState(() => getPagination());

  const CollapseItemSearch = (
    <>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item label="ชื่อสินค้า" name="stname">
            <Input placeholder="Enter Product Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item label="วันที่ขาย" name="podate">
            <RangePicker
              placeholder={["เริ่มวันที่", "ถึงวันที่"]}
              style={{ width: "100%", height: 40 }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={8} md={12} lg={12} xl={12}>
          {/* Ignore */}
        </Col>
        <Col xs={24} sm={8} md={12} lg={12} xl={12}>
          <Flex justify="flex-end" gap={8}>
            <Button
              type="primary"
              size="small"
              className="bn-action"
              icon={<SearchOutlined />}
              onClick={() => handleSearch()}
            >
              Search
            </Button>
            <Button
              type="primary"
              size="small"
              className="bn-action"
              danger
              icon={<ClearOutlined />}
              onClick={() => handleClear()}
            >
              Clear
            </Button>
          </Flex>
        </Col>
      </Row>
    </>
  );

  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => { setActiveSearch(e); saveActiveSearch(e); }}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> Search</span>
            </>
          ),
          children: <>{CollapseItemSearch}</>,
          showArrow: false,
        },
      ]}
    />
  );

  const handleSearch = () => {
    form.validateFields().then((v) => {
      const data = { ...v };
      saveSearch(v, DATE_FIELDS);
      if (!!data?.podate) {
        const arr = data?.podate.map((m) => dayjs(m).format("YYYY-MM-DD"));
        const [podate_form, podate_to] = arr;
        Object.assign(data, { podate_form, podate_to });
      }
      setTimeout(
        () =>
          reportService
            .SalesCost(data, { ignoreLoading: Object.keys(data).length !== 0 })
            .then((res) => {
              const { data } = res.data;

              setAccessData(data);
            })
            .catch((err) => {
              console.log(err);
              message.error("Request error!");
            }),
        80
      );
    });
  };

  const handleClear = () => {
    form.resetFields();
    clearSearch();
    setPagination({ current: 1, pageSize: pagination.pageSize });
    handleSearch();
  };

  const hangleAdd = () => {
    navigate("manage/create", {
      state: {
        config: { ...mngConfig, title: "สร้างใบสั่งซื้อ", action: "create" },
      },
    });
  };

  const handleEdit = (data) => {
    navigate("manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "แก้ไขใบสั่งซื้อ",
          action: "edit",
          code: data?.pocode,
        },
      },
      replace: true,
    });
  };

  const column = accessColumn({ handleEdit });

  const handleExportReportStockCard = React.useCallback( async () => {
          try {
                      await reportService.SalesCostDownload({ });

          } catch (error) {
              console.error("Error fetching report data:", error);
              return [];
          }
      }, []);

  const init = async () => {
    form.setFieldsValue(getSearch(DATE_FIELDS));
    handleSearch();
  };

  useEffect(() => {
    init();

    return async () => {
      //console.clear();
    };
  }, []);
  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            รายงานยอดขายเปรียบเทียบต้นทุน
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            icon={<TbFileExport style={TBICONSTYLE} />}
            style={TBBNTSTYLE}
            className="bn-success-outline"
            onClick={() => handleExportReportStockCard()}
          >
            <Typography.Text style={{ color: "var(--success)" }}>
              ดาวน์โหลดรายงาน
            </Typography.Text>
          </Button>
        </Flex>
      </Col>
    </Flex>
  );
  return (
    <div className="salescost-access" id="area">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          onValuesChange={() => {
            handleSearch(true);
          }}
        >
          {FormSearch}
        </Form>
        <Card>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                title={() => TitleTable}
                size="small"
                rowKey="pocode"
                columns={column}
                dataSource={accessData}
                scroll={{ x: "max-content" }}
                pagination={pagination}
                onChange={(p) => { setPagination(p); savePagination(p); }}
              />
            </Col>
          </Row>
        </Card>
      </Space>
    </div>
  );
};

export default SalesCostAccess;
